import Title from 'app/ui/display/Title';
import ScoreDisplay from 'app/ui/display/ScoreDisplay';
import HighScoreDisplay from 'app/ui/display/HighScoreDisplay';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import * as AppConstants from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';

export default class HudGameIntro extends Phaser.Group {
  constructor({ game, message, onClose = false, onCloseScope = false }) {
    super(game);

    const messageData = this.game.controller.config.getIntroMessageById(message);

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.3 });
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    // display Gnasher if player completed the level, display dennis if player did not
    this.character = this.game.make.image(0, 0, messageData.image.spritesheet, messageData.image.frame);
    this.character.y = 0;
    this.character.x = this.panel.width * 0.5 - this.character.width * 0.5;
    this.container.addAt(this.character, 0);

    // add title, positiing would depend on what character is being displayed
    this.title = new Title({ game, title: Title[messageData.title] });
    this.title.x = this.panel.width * 0.5 - this.title.width * 0.5;
    this.title.y = this.character.height * 0.7;
    this.container.add(this.title);

    this.copy = createTextField(this.game, AppConstants.FONT_COPY, 33, AppConstants.COPY_WHITE, 60, 0, {
      wordWrap: true,
      wordWrapWidth: this.panel.width * 0.8,
    });
    this.copy.angle = -2.5;
    this.copy.text = this.game.copy.getCopy(messageData.copy);
    this.copy.y = this.title.y + this.title.height + 40;
    this.container.add(this.copy);

    // adjust panel positon based on title position
    this.panel.y = this.title.y + this.title.height * 0.25;

    // continue button
    this.btnContinue = new ButtonSimple({ game: this.game, id: 'btn_continue', skin: 'btn_continue' });
    this.btnContinue.x = this.panel.width * 0.5;
    this.btnContinue.y = this.panel.y + this.panel.height - this.btnContinue.height;
    this.btnContinue.onInputDown.add(this.handleContinue, this);
    this.container.addChild(this.btnContinue);

    // and we adjust the height of the panel to suit
    this.panel.height = this.btnContinue.y - this.panel.y;

    // closed callbacks
    this.onClose = onClose;
    this.onCloseScope = onCloseScope;

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.fixedToCamera = true;
    this.handleScreenResize();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  /*
  ============================================================================================
    EVENT HANDLERS
  ============================================================================================
  */

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;
  }

  handleContinue() {
    if (this.onClose) {
      this.onClose.apply(this.onCloseScope);
    }
    this.destroy();
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    // clean up listeners
    this.btnContinue.onInputDown.remove(this.handleContinue, this);
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);

    // destroy stuff
    this.btnContinue.destroy(true);
    this.title.destroy(true);
    this.character.destroy(true);
    this.panel.destroy(true);
    this.container.destroy(true);

    // nullify
    this.btnContinue = null;
    this.title = null;
    this.character = null;
    this.panel = null;
    this.container = null;

    // super dupa
    super.destroy(true);
  }
}
